export default __webpack_public_path__ + "static/media/icon-notmute-intro.254d1056.svg";